import { useOrderStore } from '~~/common/stores/order';
import { computed } from 'vue';


export function useOrderSplit () {
  const order = computed(() => {
    return useOrderStore().order;
  });

  const splits = computed(() => {
    return Array.isArray(order.value?.splits) ? order.value.splits : [];
  });

  const editedOrderId = computed(() => {
    return useOrderStore().editedOrder?.id;
  });

  const editedOriginalOrder = computed(() => useOrderStore().editedOriginalOrder);

  return {
    splits,
    editedOrderId,
    editedOriginalOrder,
    getSplitByCheckoutType,
  };

  function getSplitByCheckoutType (checkoutType: string) {
    return splits.value.find(split => split?.checkoutType === checkoutType);
  }
}
